module.exports = __webpack_public_path__ + "assets/icons/choice.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/choice/choice.png
// module id = ./src/styles/icons/choice/choice.png
// module chunks = 0